export default __webpack_public_path__ + "static/media/permissions.44ef4250.svg";